// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"737":"18001d47","6407":"dfaa7629","9039":"dfaa7629"}[chunkId] + ".chunk.css";
};